import { VerifyStatus, defaultLanguage, DefaultConfigs } from '@/common/js/constant';
import * as request from '@/utils/request';
import { RISK_SDK_VERSION } from './index';
// 风控业务地址
const baseUrl = DefaultConfigs.publicRiskAPIPath;

const apiVersion: string = require('@/../package.json').version;


// 获取核验因子
export function query(data: { sessionId: string; verifySdkVersion: string; passportToken: string }): Promise<PageRiskDetail> {
  return request.post<{ atoDomain: PageRiskDetail }>(`${baseUrl}/sofi-risk-api/out/sofiPassportGetCheckList`, data, {
    params: {
      productName: '',
      interfaceName: 'sofi_veryfiList',
      demand: 'sofi-veryfiList',
      scene: 'GLOBAL_FINANCE_SOFI_VERIFYLIST',
      apiVersion,
    }
  }).then(ret => ret.atoDomain);
}
  
// 选择核验方式
export function select(data: {verifyType: RiskFactor; currentVerifyType: RiskFactor; sessionId: RiskToken; verifySdkVersion: string; passportToken: string;}): Promise<{status: string; verifyInfo: MethodDetail } & SwitchVerifyDetail> {
  return request.post<{status: string; verifyInfo: MethodDetail} & SwitchVerifyDetail>(`${baseUrl}/sofi-risk-api/out/sofiTriggerVerify`, data, {
    params: {
      productName: '',
      interfaceName: 'sofi_trigger_verify',
      demand: 'ofi-trigger-verify',
      scene: 'GLOBAL_FINANCE_SOFI_TRIGGER_VERIFY',
      apiVersion,
    }
  }).then(ret => {
    // 请求验证码成功状态
    if(ret.status === VerifyStatus.SUCCESS) {
      return ret;
    }
    // 失败
    return Promise.reject(ret);
  });
}
  
// 提交核验答案
export function answer(data: {verifyType: RiskFactor; answer: string; currentVerifyType: RiskFactor; sessionId: RiskToken; verifySdkVersion: string; passportToken: string; }): Promise<RiskVerifyResult> {
  return request.post<{token: RiskToken, status: VerifyStatus}>(`${baseUrl}/sofi-risk-api/out/sofiVerify`, data, {
    params: {
      productName: '',
      interfaceName: 'sofi_verify',
      demand: 'sofi-verify',
      scene: 'GLOBAL_FINANCE_SOFI_VERIFY',
      apiVersion: RISK_SDK_VERSION,
    }
  }).then(verify_data => {
    // 核验成功
    if(verify_data.status === VerifyStatus.SUCCESS ) {
      return {
        verify_data: verify_data.token,
        verify_session_id: data.sessionId,
        verifySdkVersion: data.verifySdkVersion,
      }
    }
    // 核验失败
    return Promise.reject(verify_data);
  });
}

// 发送验证码
export function sendCode() {
  return request.get<any>(`${baseUrl}/risk-api/sofiVerify`, {});
}